import { Routes } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { AuthGuardWithForcedLogin } from './core/auth/auth-guard.service';
import { HomeComponent } from './features/home/home.component';
import { IdTagsOverviewComponent } from './features/id-tags/id-tags-overview/id-tags-overview.component';
import { IncidentsOverviewComponent } from './features/incidents/components/incidents-overview/incidents-overview.component';
import { NotLoggedInComponent } from './features/not-logged-in/not-logged-in.component';
import { OrganizationListComponent } from './features/organization/components/organization-list/organization-list.component';
import { PageNotFoundComponent } from './features/page-not-found/page-not-found.component';
import { ModuleListComponent } from './features/modules/module-list/module-list.component';
import { ChargingStationLocationOverviewComponent } from './features/charging-station-location/charging-station-location-overview/charging-station-location-overview.component';
import { ChargingUsersOverviewComponent } from './features/charging-users/charging-users-overview/charging-users-overview.component';
import { UsersOverviewComponent } from './features/users/users-overview/users-overview.component';
import { LocationMapComponent } from './features/ok-app-emulator/location-map/location-map.component';
import { AccessGroupOverviewComponent } from './features/access-groups/access-group-overview/access-group-overview.component';
import { PtsOverviewComponent } from './features/payment-terminal/pts/pts-overview/pts-overview.component';

import { UserNotValidComponent } from './features/user-not-valid/user-not-valid.component';
import { CreateOrganizationWizardComponent } from './features/organization/components/create-organization-wizard/create-organization-wizard.component';
import { PriceSignOverviewComponent } from './features/price-signs/price-sign-overview/price-sign-overview.component';
import { LiveChargingDashboardComponent } from './features/live-charging-dashboard/live-charging-dashboard.component';
import { PricePoliciesComponent } from './features/prices/price-policies/price-policies.component';
import { PriceRegulationsOverviewComponent } from './features/prices/price-regulations/price-regulations-overview/price-regulations-overview.component';
import { FEATURE_FLAGS } from './shared/services/feature-flags.const';
import { FeatureFlagService } from './shared/services/feature-flag.service';
import { PtsSessionOverviewComponent } from './features/payment-terminal/pts/pts-session-overview/pts-session-overview.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuardWithForcedLogin],
  },
  { path: 'login', component: NotLoggedInComponent },
  { path: 'logout', component: UserNotValidComponent },
  {
    path: 'organizations/wizard',
    component: CreateOrganizationWizardComponent,
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'organizations',
    component: OrganizationListComponent,
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'id-tags',
    component: IdTagsOverviewComponent,
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'charging-users',
    component: ChargingUsersOverviewComponent,
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'locations',
    component: ChargingStationLocationOverviewComponent,
    canActivate: [AuthGuardWithForcedLogin],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange', // This is needed to reload the page when the user navigates to the same page
  },
  {
    path: 'incidents',
    component: IncidentsOverviewComponent,
  },
  {
    path: 'modules',
    component: ModuleListComponent,
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'payment-terminals/payter',
    component: PtsOverviewComponent,
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'payment-terminals/payter/sessions',
    component: PtsSessionOverviewComponent,
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'price-sign',
    component: PriceSignOverviewComponent,
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'price-policies',
    component: PricePoliciesComponent,
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'price-regulations',
    component: PriceRegulationsOverviewComponent,
    canActivate: [AuthGuardWithForcedLogin],
    canMatch: [
      () =>
        inject(FeatureFlagService)
          .getFeatureFlag(FEATURE_FLAGS.PRICE_REGULATIONS_READ)
          .pipe(map(flag => flag.result)),
    ],
  },
  {
    path: 'access-groups',
    component: AccessGroupOverviewComponent,
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'users',
    component: UsersOverviewComponent,
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'ok-app-emulator',
    component: LocationMapComponent,
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'live-charging-dashboard',
    component: LiveChargingDashboardComponent,
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

export default routes;
